<template>
  <FreeModal :name="name" with-blackout>
    <template #header>
      <div class="flex items-center justify-center">
        <picture>
          <source
            srcset="@/assets/images/flight-delay-icon.webp"
            type="image/webp"
          />
          <img
            src="@/assets/images/flight-delay-icon.png"
            width="56"
            height="56"
            alt=""
            role="presentation"
          />
        </picture>
      </div>
    </template>
    <template #default="{ hide }">
      <div class="mt-4 space-y-4">
        <div class="space-y-2">
          <h3
            class="text-text-neutral-primary text-center text-lg font-semibold"
          >
            {{ t('ancillaries.flightDelay.success.title') }}
          </h3>
          <i18n-t
            tag="p"
            keypath="ancillaries.flightDelay.success.description"
            class="text-text-neutral-secondary text-center text-sm"
          >
            <template #sms>
              <span class="font-semibold">
                {{ t('ancillaries.flightDelay.success.sms') }}
              </span>
            </template>
            <template #answerDelay>
              <span class="font-semibold">
                {{ t('ancillaries.flightDelay.success.answerDelay') }}
              </span>
            </template>
          </i18n-t>
        </div>
        <div class="mt-6">
          <FreeButton
            type="button"
            size="sm"
            class="green-main-button w-full"
            @click="hide"
          >
            {{ t('ancillaries.flightDelay.success.confirm') }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { FreeButton, FreeModal } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();
</script>
